<template>
  <section>
    <div class="container py-5">
      <div class="row col-12 col-md-11 col-xxl-9 mx-auto d-flex pt-5 mt-5">
        <div class="col-12 col-lg-4">
          <heading-two
            class="text-center text-lg-end font-poppins"
            text="The remarkable insights brought by attention and emotion measurement"
          />
          <!--TODO ask if this must be static or nonstatic post -->
          <div class="text-center my-4 pt-0 pt-lg-4">
            <router-link
              :to="{ name: 'BlogShow', params: { blogId: 'first' } }"
              class="btn btn-light text-info shadow rounded-pill px-5 fs-5 font-montserrat fw-light"
            >
              Read More
            </router-link>
          </div>
        </div>
        <div class="col-12 col-lg-7 offset-lg-1 px-xxl-5">
          <paragraph-size-six
            paragraph-text="Impala is the first neuromarketing DIY platform that enables you to gain a deep understanding of human behavior. It provides you with out of the box data to take your marketing strategy to the next level."
            line-height="lh-xl"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "TheRemarkableInsightsSection",
  components: { ParagraphSizeSix, HeadingTwo },
};
</script>
<script setup>
import HeadingTwo from "@/components/base-components/HeadingTwo";
import ParagraphSizeSix from "@/components/base-components/ParagraphSizeSix";
</script>

<style scoped></style>
